import { render, staticRenderFns } from "./FAQ 2.0.vue?vue&type=template&id=2a080a1c&scoped=true&"
import script from "./FAQ 2.0.vue?vue&type=script&lang=js&"
export * from "./FAQ 2.0.vue?vue&type=script&lang=js&"
import style0 from "./FAQ 2.0.vue?vue&type=style&index=0&id=2a080a1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a080a1c",
  null
  
)

export default component.exports